import React, { useState } from "react";

const ProfileImagePreview = ({ file }) => {
  const [preview, setPreview] = useState();

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    setPreview(reader.result);
  };
  return (
    <>
      {preview ? (
        <img
          alt="User Pic"
          src={preview}
          id="profile-image1"
          height="200"
          width="200"
          style={{ cursor: "pointer", borderRadius: "50%" }}
        />
      ) : (
        "Loading"
      )}
    </>
  );
};

export default ProfileImagePreview;
